export enum CATEGORIES_KEY {
  CATEGORY_1 = "公告",
  CATEGORY_2 = "配当",
  CATEGORY_3 = "招集",
  CATEGORY_4 = "決議",
}

export const CATEGORIES = {
  [CATEGORIES_KEY.CATEGORY_1]: "公告",
  [CATEGORIES_KEY.CATEGORY_2]: "配当情報",
  [CATEGORIES_KEY.CATEGORY_3]: "招集通知",
  [CATEGORIES_KEY.CATEGORY_4]: "決議通知",
};
